var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AIHubSharedExecutionContextProviderAppContext, AIHubSharedExecutionContextProviderLazy as AIHubSharedExecutionContextProviderReactLazy, } from '@office-start/ai-hub-execution-context-provider-lazy';
import { withLazyErrorBoundary } from '@office-start/error-boundary';
import { OfficeWorkload, } from '@office-start/officehome-types';
import { IMMEDIATE_PRIORITY } from '@office-start/scheduler-service';
import createBrowserHistory from 'history/createBrowserHistory';
import withQuery from 'history-query-enhancer';
import queryString from 'query-string';
import React from 'react';
import { Router } from 'react-router-dom';
import AIHubAppHostedPage from './Components/AIHubAppHostedPage/AIHubAppHostedPage';
import { getAppHostedRoutes } from './routing/getAppHostedRoutes';
/**
 * Ensure Lazy component is wrapped with ErrorBoundary
 * AIHubSharedExecutionContextProviderReactLazy doesn't have access to withLazyErrorBoundary
 */
var AIHubSharedExecutionContextProviderLazyErrorBoundary = withLazyErrorBoundary(AIHubSharedExecutionContextProviderReactLazy, 'AIHubSharedExecutionContextProvider', {
    schedulePriority: IMMEDIATE_PRIORITY,
});
export var OfficeAppHosted = function (props) {
    var history = withQuery(queryString)(createBrowserHistory());
    return (React.createElement(Router, { history: history },
        React.createElement(AppHostedV3Setup, __assign({}, props))));
};
/**
 * Setup component context in this 'setup' component, so that it is only done once.
 * Do not re-render components that re-initialize context.
 * @param props OfficeExperienceContext
 * @returns
 */
var AppHostedV3Setup = function (props) {
    var rootPath = props.rootPath || '';
    var officeHomeAppRouteConfig = getAppHostedRoutes(rootPath);
    var workload = OfficeWorkload.OfficeHomeReact;
    var sharedExecutionContextProviderAppContextValue = React.useMemo(function () { return ({
        officeExperienceContext: props,
        workload: workload,
        initialLoadAIHubSharedContext: true,
        AIHubSharedExecutionContextProviderLazyErrorBoundary: AIHubSharedExecutionContextProviderLazyErrorBoundary,
    }); }, [props, workload]);
    return (React.createElement(AIHubSharedExecutionContextProviderAppContext.Provider, { value: sharedExecutionContextProviderAppContextValue },
        React.createElement(AIHubAppHostedPage, { officeHomeAppRouteConfig: officeHomeAppRouteConfig, componentContext: props })));
};
//# sourceMappingURL=OfficeAppHosted.js.map